import React from 'react';
import { motion } from 'framer-motion';
import '../styles/ZodiacWheel.css';

const ZodiacWheel = () => {
  return (
    <motion.svg
      className="zodiac-wheel"
      viewBox="0 0 200 200"
      xmlns="http://www.w3.org/2000/svg"
      animate={{ rotate: 360 }}
      transition={{
        duration: 120,
        repeat: Infinity,
        ease: 'linear',
      }}
    >
      {/* Outer circles */}
      <motion.circle
        cx="100"
        cy="100"
        r="90"
        fill="none"
        stroke="rgba(100, 77, 0, 0.49)"
        strokeWidth="0.5"
        initial={{ pathLength: 0 }}
        animate={{ pathLength: 1 }}
        transition={{ duration: 2, ease: 'easeInOut' }}
      />
      <motion.circle
        cx="100"
        cy="100"
        r="70"
        fill="none"
        stroke="rgba(100, 77, 0, 0.49)"
        strokeWidth="0.5"
        initial={{ pathLength: 0 }}
        animate={{ pathLength: 1 }}
        transition={{ duration: 2, delay: 0.2, ease: 'easeInOut' }}
      />
      <motion.circle
        cx="100"
        cy="100"
        r="50"
        fill="none"
        stroke="rgba(100, 77, 0, 0.49)"
        strokeWidth="0.5"
        initial={{ pathLength: 0 }}
        animate={{ pathLength: 1 }}
        transition={{ duration: 2, delay: 0.4, ease: 'easeInOut' }}
      />

      {/* Cross lines */}
      <motion.line
        x1="100"
        y1="10"
        x2="100"
        y2="190"
        stroke="rgba(161, 124, 3, 0.6)"
        strokeWidth="0.5"
        initial={{ pathLength: 0 }}
        animate={{ pathLength: 1 }}
        transition={{ duration: 1.5, delay: 0.6 }}
      />
      <motion.line
        x1="10"
        y1="100"
        x2="190"
        y2="100"
        stroke="rgba(161, 124, 3, 0.6)"
        strokeWidth="0.5"
        initial={{ pathLength: 0 }}
        animate={{ pathLength: 1 }}
        transition={{ duration: 1.5, delay: 0.7 }}
      />
      <motion.line
        x1="35"
        y1="35"
        x2="165"
        y2="165"
        stroke="rgba(161, 124, 3, 0.6)"
        strokeWidth="0.5"
        initial={{ pathLength: 0 }}
        animate={{ pathLength: 1 }}
        transition={{ duration: 1.5, delay: 0.8 }}
      />
      <motion.line
        x1="165"
        y1="35"
        x2="35"
        y2="165"
        stroke="rgba(161, 124, 3, 0.6)"
        strokeWidth="0.5"
        initial={{ pathLength: 0 }}
        animate={{ pathLength: 1 }}
        transition={{ duration: 1.5, delay: 0.9 }}
      />

      {/* Zodiac symbols positioned around the wheel */}
      {[...Array(12)].map((_, i) => {
        const angle = (i * 30 - 90) * (Math.PI / 180);
        const x = 100 + 80 * Math.cos(angle);
        const y = 100 + 80 * Math.sin(angle);

        return (
          <motion.circle
            key={i}
            cx={x}
            cy={y}
            r="3"
            fill="rgb(224, 181, 36)"
            initial={{ scale: 0, opacity: 0 }}
            animate={{ scale: 1, opacity: 0.5 }}
            transition={{ delay: 1 + i * 0.1, duration: 0.5 }}
          />
        );
      })}

      {/* Center star */}
      <motion.circle
        cx="100"
        cy="100"
        r="5"
        fill="rgba(212, 175, 55, 0.8)"
        initial={{ scale: 0 }}
        animate={{ scale: [0, 1.2, 1] }}
        transition={{ delay: 2, duration: 0.8 }}
      />
    </motion.svg>
  );
};

export default ZodiacWheel;
